import React, { useState, useEffect, useContext } from "react";
import fetchHook from "../../hooks/fetchMSSQL-hook";
import { NavigationContext } from "../../context/navigation-context";
import SearchFilter from "../../components/Filter/SearchFilter";
import formHook from "../../hooks/form-hook";
import { NotificationManager } from "react-notifications";
import MaintenanceForm from "../../components/Modals/MaintenanceForm";

export default function MaintenanceTypes() {
  const [types, setTypes] = useState([]);
  const { fetchMssqlApi } = fetchHook();
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const { setHeaderData } = useContext(NavigationContext);
  const { form, openForm, closeForm } = formHook();

  const getCheckboxFromBool = (bool) => (
    <div className="d-flex justify-content-center align-items-center">
      <input type="checkbox" checked={!!bool} readOnly style={{ pointerEvents: "none" }} />
    </div>
  );

  const defaultFilter = {
    page: 1,
    rowsPerPage: 100,
    isActive: "true",
  };

  const [filter, setFilter] = useState(defaultFilter);
    const [settingsFilter, setSettingsFilter] = useState({
      saveFilters: true,
      autoLoading: true,
      additionalFilter: true,
      flatView: false,
      rowsPerPage: 50,
    });

  const rowsPerPage = settingsFilter.rowsPerPage || filter.rowsPerPage || 50;

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight)

      const screenHeight = window.innerHeight
      const reservedSpace = 350
      const visibleRows = Math.floor((screenHeight - reservedSpace) / 40)

      setFilter(prev => ({
        ...prev,
        rowsPerPage: visibleRows > 50 ? 50 : visibleRows,
      }))
    }

    window.addEventListener("resize", handleResize)
    handleResize()

    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const handleSubmit = (evt) => {
    evt.preventDefault();
    const f = evt.target;

  const submitter = evt.nativeEvent?.submitter;
  const isToggle = submitter?.id === "isActive";

  const payload = {
    Name: f.name.value.trim(),
    HasEVADTS: f.HasEVADTS.checked,
    IsCoffee: f.IsCoffee.checked,
    IsSnack: f.IsSnack.checked,
    IsCalcDiff: f.IsCalcDiff.checked,
    IsTotalCoinsRequired: f.IsTotalCoinsRequired.checked,
    IsTotalSalesRequired: f.IsTotalSalesRequired.checked,
    IsCorrectionCommentRequired: f.IsCorrectionCommentRequired.checked,
    ShowMachineName: f.ShowMachineName.checked,
    ShowMachineLocation: f.ShowMachineLocation.checked,
    HasTelemetry: f.HasTelemetry.checked,
    IsCoinBagMandatory: f.IsCoinBagMandatory.checked,
    IsOverpayRequired: f.IsOverpayRequired.checked,
    IsTotalSalesHidden: f.IsTotalSalesHidden.checked,
    OrderByProduct: f.OrderByProduct.checked,
    UseCoffeeInventory: f.UseCoffeeInventory.checked,
    IsActive: f.IsActive?.checked ?? true
  };

  if (!payload.Name) {
    NotificationManager.error("Brak nazwy");
    return;
  }

  if (form === "new") {
    fetchMssqlApi(
      "maintenance-type",
      { method: "POST", data: payload },
      () => {
        getMaintenanceTypes(filter);
        closeForm();
      }
    );
  } else {
    if (isToggle) {
      const current = types.find(t => t.MaintenanceTypeId === form);
      const nextIsActive = !Boolean(current?.IsActive);

      return fetchMssqlApi(
        `maintenance-type/${form}`,
        { method: "PUT", data: { ...current, IsActive: nextIsActive } },
        () => {
          getMaintenanceTypes(filter);
          closeForm();
        }
      );
    }

    fetchMssqlApi(
      `maintenance-type/${form}`,
      { method: "PUT", data: payload },
      () => {
        getMaintenanceTypes(filter);
        closeForm();
      }
    );
  }
};
  const parseThreeState = (val) => {if (val === "false") return false; if (val === "true") return true; return null}; 
  const getMaintenanceTypes = (f) => {
    fetchMssqlApi("maintenance-types", {method: "POST", hideNotification: true, data: {isActive: parseThreeState(f?.isActive)}}, (res) => {
      setTypes(Array.isArray(res) ? res : []);
    });
  };

  useEffect(() => {
    setHeaderData({ text: "Tryby obsługi" });
  }, []);

  return (
    <>
      {form && (
        <MaintenanceForm
          maintenanceData={types.find((mt) => mt.MaintenanceTypeId === form)}
          handleSubmit={handleSubmit}
          handleClose={closeForm}
        />
      )}

      <div>

      <SearchFilter
        filterName="maintenanceType"
        defaultFilter={defaultFilter}
        onFilterChange={(f) => setFilter(prev => ({ ...prev, ...f }))}
        onSettingsChange={(s) => setSettingsFilter(prev => ({ ...prev, ...s }))}
        search={getMaintenanceTypes}
        totalCount={types.slice(
          (filter.page - 1) * rowsPerPage,
          filter.page * rowsPerPage
        ).length}
        forNow
      />

        <div className="card">
          <div className="card-header">
            <div className="d-flex justify-content-between">
              <div></div>

              <div
                onClick={openForm("new")}
                className="btn text-nowrap btn-outline-secondary mt-1 mb-1"
              >
                <i className="fas fa-plus" />
              </div>
            </div>
          </div>

        <div
          className="overflow-auto custom-scroll"
          style={{
            maxHeight: `${windowHeight - 214}px`,
            overflowY: "auto",
          }}
        >
            {types.length ? (
              <table className="table table-striped maintenance-table">
                <thead>
                  <tr className="headers-color pe-none">
                    <th className="text-center align-middle short">Nazwa</th>
                    <th className="text-center align-middle short">EVADTS</th>
                    <th className="text-center align-middle short">Kawa</th>
                    <th className="text-center align-middle short">Snack</th>
                    <th className="text-center align-middle">
                      Rozliczanie poprzez odejmowanie sum sprzedaży ilościowej na wyborze
                    </th>
                    <th className="text-center align-middle">
                      Spisywanie licznika gotówkowego wymagane podczas wybierania monet
                    </th>
                    <th className="text-center align-middle">
                      Spisywanie licznika ilościowego wymagane podczas wybierania monet
                    </th>
                    <th className="text-center align-middle">
                      Komentarz do korekty jest wymagany
                    </th>
                    <th className="text-center align-middle">
                      Wyświetlaj Nazwę automatu w jego "pełnej nazwie"
                    </th>
                    <th className="text-center align-middle">
                      Wyświetlaj lokalizacje automatu w jego "pełnej nazwie"
                    </th>
                    <th className="text-center align-middle short">Telemetria</th>
                    <th className="text-center align-middle">
                      Wybór torby na gotówkę jest wymagany
                    </th>
                    <th className="text-center align-middle">
                      Spisywanie licznika gotówkowego nadpłaty wymagane podczas wybierania monet
                    </th>
                    <th className="text-center align-middle">Ukryj sprzedaż całkowitą</th>
                    <th className="text-center align-middle">Sortuj wybory wg nazw produktów</th>
                    <th className="text-center align-middle">
                      Używaj inwentaryzacji stanu automatu kawowego
                    </th>
                    <th className="text-center align-middle short">Aktywne</th>
                    <th></th>
                  </tr>
                </thead>

                <tbody>
                  {types.slice((filter.page - 1) * rowsPerPage, filter.page * rowsPerPage).map((item, idx) => (
                    <tr key={item.MaintenanceTypeId ?? `temp-${idx}`} className="mt-1 mb-1">
                      <td>{item.Name}</td>
                      <td><i className={item.HasEVADTS ? "fas fa-check-square text-primary" : "far fa-square text-primary"}/></td>
                      <td><i className={item.IsCoffee ? "fas fa-check-square text-primary" : "far fa-square text-primary"}/></td>
                      <td><i className={item.IsSnack ? "fas fa-check-square text-primary" : "far fa-square text-primary"}/></td>
                      <td><i className={item.IsCalcDiff ? "fas fa-check-square text-primary" : "far fa-square text-primary"}/></td>
                      <td><i className={item.IsTotalCoinsRequired ? "fas fa-check-square text-primary" : "far fa-square text-primary"}/></td>
                      <td><i className={item.IsTotalSalesRequired ? "fas fa-check-square text-primary" : "far fa-square text-primary"}/></td>
                      <td><i className={item.IsCorrectionCommentRequired ? "fas fa-check-square text-primary" : "far fa-square text-primary"}/></td>
                      <td><i className={item.ShowMachineName ? "fas fa-check-square text-primary" : "far fa-square text-primary"}/></td>
                      <td><i className={item.ShowMachineLocation ? "fas fa-check-square text-primary" : "far fa-square text-primary"}/></td>
                      <td><i className={item.HasTelemetry ? "fas fa-check-square text-primary" : "far fa-square text-primary"}/></td>
                      <td><i className={item.IsCoinBagMandatory ? "fas fa-check-square text-primary" : "far fa-square text-primary"}/></td>
                      <td><i className={item.IsOverpayRequired ? "fas fa-check-square text-primary" : "far fa-square text-primary"}/></td>
                      <td><i className={item.IsTotalSalesHidden ? "fas fa-check-square text-primary" : "far fa-square text-primary"}/></td>
                      <td><i className={item.OrderByProduct ? "fas fa-check-square text-primary" : "far fa-square text-primary"}/></td>
                      <td><i className={item.UseCoffeeInventory ? "fas fa-check-square text-primary" : "far fa-square text-primary"}/></td>
                      <td><i className={item.IsActive ? "fas fa-check-square text-primary" : "far fa-square text-primary"}/></td>
                      <td>
                        <button
                          onClick={openForm(item.MaintenanceTypeId)}
                          className="btn btn-outline-primary btn-sm"
                        >
                          Edytuj
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="h3 d-flex justify-content-center align-items-center">
                Brak danych
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
